export default {
  common_canNotBeEmpty: 'Ne peut être vide',
  // #region首页
  main_collection_function: 'Fonction de Favoris',
  main_menu_bar_management: 'Gestion de la Barre de Menu',
  // #endregion

  // #region Header
  main_header_download_app: 'Télécharger l\'APP',
  main_header_recent_visit: 'Visites Récentes',
  main_header_placeholder: 'Rechercher',
  main_header_IT_system: 'Système IT',
  main_header_todo_center: 'Centre des Tâches',
  main_header_message_remind: 'Notifications',
  main_header_change_SYS_password: 'Modifier le Mot de Passe',
  main_header_log_out: 'Déconnexion',
  main_header_log_out_tip: 'Confirmez-vous la déconnexion ?',
  main_header_log_out_title: 'Confirmation de Déconnexion',
  main_header_confirm: 'Confirmer',
  main_header_cancel: 'Annuler',
  main_header_change_name: 'Nom',
  main_header_change_Work_number: 'Matricule',
  main_header_old_password: 'Ancien Mot de Passe',
  main_header_old_password_placeholder: 'Veuillez entrer le mot de passe initial',
  main_header_new_password: 'Nouveau Mot de Passe',
  main_header_new_password_placeholder: 'Veuillez entrer un nouveau mot de passe',
  main_header_confirm_password: 'Confirmer le Mot de Passe',
  main_header_confirm_password_placeholder: 'Veuillez confirmer le mot de passe',
  main_header_messageObj_prompt: 'Information',
  main_header_messageObj_length: 'Le mot de passe doit contenir 8 à 16 caractères',
  main_header_messageObj_three_condition: 'Doit contenir au moins 3 types parmi : majuscules, minuscules, chiffres, symboles spéciaux',
  main_header_messageObj_no_repeat: 'Ne pas autoriser 3 chiffres consécutifs ou répétés (ex: 345, 333)',
  main_header_messageObj_old_new_different: 'Le nouveau mot de passe ne peut pas être identique à l\'ancien',
  main_header_messageObj_twice_different: 'Les deux mots de passe saisis doivent être identiques',
  main_header_change_success: 'Modification réussie',
  main_header_refresh: 'Actualiser',
  main_header_close: 'Fermer',
  main_header_close_all: 'Tout Fermer',
  main_header_close_addition: 'Tout Fermer Sauf Celui-ci',
  main_header_close_right: 'Fermer Tout à Droite',
  main_header_close_left: 'Fermer Tout à Gauche',
  // #endregion

  // #region 首页
  main_home_home_name: 'Accueil',
  main_home_todo_title: 'Mes Tâches',
  main_home_todo_more: 'Plus',
  main_home_todo_checkAll: 'Tout Sélectionner',
  main_home_todo_batchProcess: 'Traitement par Lot',
  main_home_todo_complaint: 'Réassigner',
  main_home_todo_approve: 'Approuver',
  main_home_todo_reject: 'Rejeter',
  main_home_todo_toDealWith: 'Traiter',
  main_home_todo_work_dealed: 'Félicitations ! Vous avez terminé tout votre travail !',
  main_home_todo_no_data: 'Aucune donnée',
  main_home_todo_current_select: 'Actuellement sélectionné(s)',
  main_home_todo_data_num: 'élément(s) de données',
  main_home_todo_all: 'Tous',
  main_home_todo_approve_tip: 'Confirmez-vous l\'approbation de ces données ?',
  main_home_todo_approve_title: 'Approbation',
  main_home_todo_confirm: 'Confirmer',
  main_home_todo_cancel: 'Annuler',
  main_home_todo_approve_success: 'Approuvé avec succès !',
  main_home_todo_reject_title: 'Rejet',
  main_home_todo_reject_reason: 'Veuillez indiquer la raison du rejet',
  main_home_todo_reject_success: 'Rejet réussi !',
  main_home_quick_title: 'Accès Rapide',
  main_home_quick_create: 'Créer un Raccourci',
  main_home_quick_cancel_common: 'Retirer des Favoris',
  main_home_quick_set_common: 'Définir comme Favori',
  main_home_quick_sort: 'Trier',
  main_home_quick_recommend: 'Définir comme Application Recommandée',
  main_home_quick_add_common: 'Ajouter aux Favoris',
  main_home_quick_no_data: 'Aucune donnée',
  main_home_quick_cancel_common_success: 'Retiré des Favoris avec succès !',
  main_home_quick_set_common_success: 'Défini comme Favori avec succès !',
  main_home_quick_recommend_success: 'Défini comme Application Recommandée avec succès !',
  main_home_report_transhipment: 'Transbordement - Fret Aérien',
  main_home_report_no_data: 'Aucune donnée',
  main_home_report_clearance: 'Douane - Documents de Dédouanement',
  main_home_report_risk_control: 'Douane - Contrôle des Risques',
  main_home_micro_loading: 'Chargement du système...',
  main_header_full_screen: 'Plein Écran',
  main_header_exit_full_screen: 'Quitter le Plein Écran',
  main_header_forced_refresh: 'Forcer l\'Actualisation',
  // #endregion

  // #region request tips
  main_request_tip_exist_environ: 'Environnement inexistant',
  main_request_tip_login_expired: 'Connexion expirée, veuillez vous reconnecter',
  main_request_tip_no_legal: 'Aucune autorisation, veuillez contacter l\'administrateur',
  main_request_tip_server_error: 'Erreur serveur, veuillez contacter l\'administrateur',
  main_request_504_error: 'Délai d\'attente de la passerelle, veuillez réessayer',
  main_request_tip_system_error: 'Erreur système, veuillez contacter l\'administrateur',
  main_request_tip_timeout: 'Délai de requête dépassé, veuillez actualiser et réessayer',
  main_request_copy_success: 'Copié avec succès',
  main_request_tip_confirm: 'Confirmer',
  main_request_tip_cancel: 'Annuler',
  main_request_tip_delete_success: 'Supprimé avec succès',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: 'Bienvenue sur le Système GOFO',
  main_login_loading_failure: 'Échec du chargement de l\'environnement, veuillez actualiser et réessayer',
  main_login_morning_greetings: 'Bonjour',
  main_login_noon_greetings: 'Bonjour',
  main_login_afternoon_greetings: 'Bon après-midi',
  main_login_night_greetings: 'Bonsoir',
  main_login_account: 'Numéro de téléphone',
  main_login_placeholder_input: 'Veuillez saisir',
  main_login_password: 'Mot de Passe',
  main_login_retrieve_password: 'Récupérer le Mot de Passe',
  main_login_btn_text: 'Connexion',
  main_login_account_tip: 'Veuillez saisir votre numéro de téléphone',
  main_login_password_tip: 'Veuillez saisir votre mot de passe',
  main_login_account_error: 'Compte ou mot de passe incorrect',
  main_login_retrieve_back: 'Retour',
  main_login_select_account: 'Sélectionner le Compte à Récupérer',
  main_login_select_way: 'Choisir la Méthode de Récupération',
  main_login_authentication: 'Vérification d\'Identité',
  main_login_reset_password: 'Réinitialiser le Mot de Passe',
  main_login_work_number: 'Matricule',
  main_login_work_number_tip: 'Veuillez saisir le matricule à récupérer',
  main_login_customer_tip: 'Vous effectuez une opération de réinitialisation du mot de passe pour',
  main_login_operation_tip: 'pour réinitialiser le mot de passe',
  main_login_verification_code: 'Cliquez pour obtenir le code de vérification, un e-mail sera envoyé à votre boîte mail',
  main_login_verification_code_tip: 'Veuillez saisir le code de vérification',
  main_login_send_verification_code: 'Envoyer le Code de Vérification',
  main_login_name: 'Nom',
  main_login_new_password: 'Nouveau Mot de Passe',
  main_login_new_password_tip: 'Veuillez saisir un nouveau mot de passe',
  main_login_new_password_again_tip: 'Saisissez à nouveau le nouveau mot de passe',
  main_login_next_step: 'Suivant',
  main_login_save: 'Enregistrer',
  main_login_reset_password_succeeded: 'Réinitialisation du mot de passe réussie, veuillez vous reconnecter',
  main_login_work_number_input: 'Veuillez saisir le matricule',
  main_login_six_verification_code: 'Veuillez saisir le code de vérification à 6 chiffres',
  main_login_mail: 'Par E-mail',
  main_login_unknown_way: 'Méthode de vérification inconnue',
  main_login_get_in: 'Entrée dans le système, veuillez patienter',
  main_login_no_exist_page: 'Vous n\'avez pas l\'autorisation ou cette page n\'existe pas',
  main_login_no_exist_page_tip: 'Veuillez vérifier si le chemin est correct, ou cliquez sur le bouton pour retourner à l\'accueil. En cas de problème, veuillez contacter l\'administrateur',
  main_login_no_exist_back: 'Retour à l\'Accueil',
  main_login_no_last_back: 'Retour à la Page Précédente',
  main_login_link_not_exist: 'Le lien n\'existe pas',
  main_login_privacy_agree: 'Continuer signifie que vous acceptez nos',
  main_login_privacy_title_1: 'Conditions de service',
  main_login_privacy_confirm: 'confirmé et lu',
  main_login_privacy_title_2: 'Politique de confidentialité',
  main_login_privacy_tip: 'Avant de vous connecter, veuillez lire et confirmer notre',
  main_login_privacy_think_btn: 'Réfléchir',
  main_login_privacy_agree_btn: 'Accepter',
  main_login_privacy_with: 'et'
  // #endregion
}
